import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageSemesters = () => {
  const [semesters, setSemesters] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [semesterName, setSemesterName] = useState('');
  const [selectedProgramId, setSelectedProgramId] = useState('');
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    axios.get("http://localhost:8081/api/admin/programs")
      .then(res => setPrograms(res.data))
      .catch(err => console.error("Failed to fetch programs:", err));

    axios.get("http://localhost:8081/api/admin/semesters")
      .then(res => setSemesters(res.data))
      .catch(err => console.error("Failed to fetch semesters:", err));
  }, []);

  const openAddModal = () => {
    setSemesterName('');
    setSelectedProgramId('');
    setModalMode('add');
    setModalOpen(true);
  };

  const openEditModal = (semester, index) => {
    setSemesterName(semester.name);
    const matchedProgram = programs.find(p => p.name == semester.program);
    setSelectedProgramId(matchedProgram?.id || '');
    setModalMode('edit');
    setEditIndex(index);
    setModalOpen(true);
  };

  const saveSemester = async () => {
    if (!semesterName || !selectedProgramId) return;

    const selectedProgram = programs.find(p => p.id == selectedProgramId);
    console.log(programs);
    console.log(selectedProgram);
    console.log(selectedProgramId);
    
    try {
      if (modalMode === 'add') {
        const res = await axios.post("http://localhost:8081/api/admin/semesters", {
          name: semesterName,
          program: selectedProgram.name,
          program_id: selectedProgramId,
        });
        setSemesters([...semesters, {
          id: res.data.semester_id,
          name: semesterName,
          program: selectedProgram.name,
        }]);
      } else if (modalMode === 'edit') {
        const id = semesters[editIndex].id;
        await axios.put(`http://localhost:8081/api/admin/semesters/${id}`, {
          name: semesterName,
          program: selectedProgram.name,
          program_id: selectedProgramId,
        });
        const updated = [...semesters];
        updated[editIndex] = { id, name: semesterName, program: selectedProgram.name };
        setSemesters(updated);
      }

      setModalOpen(false);
      setSemesterName('');
      setSelectedProgramId('');
      setEditIndex(null);
    } catch (error) {
      console.error("Error saving semester:", error);
    }
  };

  const deleteSemester = async (index, id) => {
    try {
      console.log(index, id);
      
      await axios.delete(`http://localhost:8081/api/admin/semesters/${id}`);
      const updated = [...semesters];
      updated.splice(index, 1);
      setSemesters(updated);
    } catch (error) {
      console.error("Error deleting semester:", error);
    }
  };

  return (
    <div className="manage-semesters manage-programs-semesters">
      <div className="header">
        <h2>Manage Semesters</h2>
        <button className="add-btn" onClick={openAddModal}>Add Semester</button>
      </div>

      <table className="semesters-table">
        <thead>
          <tr>
            <th>Semester</th>
            <th>Program</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {semesters.map((semester, index) => (
            <tr key={semester.semester_id}>
              <td>{semester.name}</td>
              <td>{semester.program}</td>
              <td>
                <button className="edit" onClick={() => openEditModal(semester, index)}>Edit</button>
                <button className="delete" onClick={() => deleteSemester(index, semester.semester_id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalOpen && (
        <div className="manage-students__modal-overlay">
          <div className="manage-students__modal">
            <h3>{modalMode === 'add' ? "Add Semester" : "Edit Semester"}</h3>

            <select
              value={selectedProgramId}
              onChange={(e) => {
                 setSelectedProgramId(e.target.value)
              }
                
              }
            >
              <option value="">Select Program</option>
              {programs.map((program) => (
                <option key={program.id} value={program.id}>
                  {program.name}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Semester Name"
              value={semesterName}
              onChange={(e) => setSemesterName(e.target.value)}
            />

            <div className="manage-students__modal-actions">
              <button className="cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="save-btn" onClick={saveSemester}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageSemesters;
